import React from "react";
import Header from "../components/Header";
import TestimonialsList from "../components/TestimonialsList";
import Section from "../components/Ui/Section";
import WhoProf from "../components/WhyProf/WhoProf";
import ServisCard from "../components/ServisCard";
import MainSubscripe from "../components/MainSubscripe";
import { useTranslation } from "react-i18next";
import { Box, Container, Typography } from "@mui/material";
import SumServ from "../components/SumServ";
import mainServ from './../assets/data.jpg'
import SlideLogo from "../components/Slider/SlideLogo";
import partiner1 from "./../assets/partner/cost1.jpg";
import partiner3 from "./../assets/partner/cost3.jpg";
import partiner4 from "./../assets/partner/cost4.jpg";
import partiner5 from "./../assets/partner/cost5.jpg";
import partiner8 from "./../assets/partner/cost8.jpg";
function Home() {
    const { t } = useTranslation()

    return (
        <>
            <Header />
            <Section>

                <WhoProf
                    title={t("aboutUs.aboutTheProf")}
                    desc={t("home.whyCamelexpressDesc")}
                    titleLed={t('home.byTheExecutiveDirector')}
                    descLed={t('home.byTheExecutiveDirectorDesc')}
                />
            </Section>
            {/* <Section >
                <TestimonialsList />
            </Section> */}
            <SumServ />
            <Container maxWidth="lg">
                {/* <Box
                    sx={{
                        marginTop: 10,
                        marginBottom: 2,
                    }}
                >
                    <Typography
                        variant="h4"
                        component="h3"
                        sx={{
                            mb: "10px",
                            fontWeight: "bold",
                            color: "#76232d",
                            textAlign: 'center'
                        }}
                    >
                        {t('home.SerciceOneDesk')}
                    </Typography>
                </Box> */}
                <ServisCard
                    img={mainServ}
                    title={t('home.SerciceOne')}
                    desc={<ol type='A'>
                        <li>{t('home.SerciceOneDeskA')}</li>
                        <li>{t('home.SerciceOneDeskB')}</li>
                        <li>{t('home.SerciceOneDeskC')}</li>
                        <li>{t('home.SerciceOneDeskD')}</li>
                        <li>{t('home.SerciceOneDeskE')}</li>
                        <li>{t('home.SerciceOneDeskF')}</li>
                    </ol>}
                    img2={mainServ}
                    title2={t('home.SerciceTow')}
                    desc2={<ol type='A'>
                        <li>{t('home.SerciceTowDeskA')}</li>
                        <li>{t('home.SerciceTowDeskB')}</li>
                        <li>{t('home.SerciceTowDeskC')}</li>
                        <li>{t('home.SerciceTowDeskD')}</li>
                    </ol>}
                />
            </Container>
            <Section title={t("home.Testimonials")}>
                <Box
                    display={'flex'}
                    alignItems={'center'}
                    flexDirection={'column'}
                    sx={{ direction: 'rtl' }}
                >
                    <SlideLogo
                        image_1={partiner1}
                        // image_2={partiner2}
                        image_3={partiner3}
                        image_4={partiner4}
                        image_5={partiner5}
                        // image_6={partiner6}
                        // image_7={partiner7}
                        image_8={partiner8}
                    // image_9={partiner9}
                    />
                </Box>
            </Section>
            <Section>
                <MainSubscripe />
            </Section>
        </>
    );
}

export default Home;
